import {homeMatchResignationSurveyOptions} from "../../../constants/home_match_resignation_survey_options";
import {hitGoogleTagManager} from "../../tracking/gtm/gtm_hit";

export const hitGtmToggleHomeMatchSubscription = (checked: boolean) => {
    const gtmData = {
        event: "automatic_recommendations",
        event_action: "toggle_switch",
        event_label: checked ? "on" : "off",
        event_category: "homematch"
    };

    hitGoogleTagManager(gtmData);
};

const getReasonLabel = (reason?: string) => {
    return homeMatchResignationSurveyOptions.find((option) => option.value === reason)?.label;
};

export const hitGtmHomeMatchResignationConfirmation = (reason?: string) => {
    const gtmData = {
        event: "homematch_abandoned",
        event_action: "abandoned",
        event_label: getReasonLabel(reason)?.substring(0, 10),
        event_category: "homematch"
    };

    hitGoogleTagManager(gtmData);
};
import {homeMatchResignationSurveyOptions} from "../../../constants/home_match_resignation_survey_options";
import {hitGoogleTagManager} from "../../tracking/gtm/gtm_hit";

export const hitGtmToggleHomeMatchSubscription = (checked: boolean) => {
    const gtmData = {
        event: "automatic_recommendations",
        event_action: "toggle_switch",
        event_label: checked ? "on" : "off",
        event_category: "homematch"
    };

    hitGoogleTagManager(gtmData);
};

const getReasonLabel = (reason?: string) => {
    return homeMatchResignationSurveyOptions.find((option) => option.value === reason)?.label;
};

export const hitGtmHomeMatchResignationConfirmation = (reason?: string) => {
    const gtmData = {
        event: "homematch_abandoned",
        event_action: "abandoned",
        event_label: getReasonLabel(reason)?.substring(0, 10),
        event_category: "homematch"
    };

    hitGoogleTagManager(gtmData);
};
